"use client";

import type { ComponentProps } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * React 19, `next-themes` içindeki tema senkron script’ini client’ta uyarısız göstermek için.
 * @see https://github.com/pacocoursey/next-themes/issues/387
 */
const scriptPropsClient: ComponentProps<typeof NextThemesProvider>["scriptProps"] = {
  type: "application/json",
};

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const scriptProps =
    typeof window === "undefined" ? undefined : scriptPropsClient;

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      themes={["light", "dark", "cloud"]}
      disableTransitionOnChange
      scriptProps={scriptProps}
    >
      {children}
    </NextThemesProvider>
  );
}
